import { memo } from 'react'
import { isEqual } from 'lodash'
import AccountManagementContainer from 'app/containers/AccountManagement'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const AccountManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.account_management)}</PageTitle>
      <AccountManagementContainer />
    </>
  )
}
export const AccountManagementPage = memo(AccountManagementCpn, isEqual)
